import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject;

import * as React from "react";
import styled from "../../styled-components";
import { flexbox } from "styled-system";
import { Box } from "./Box";
export var Flex = styled(Box)(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  display: flex;\n  ", "\n"])), flexbox);
export function FlexSection(a) {
  return /*#__PURE__*/React.createElement(Flex, Object.assign({}, a, {
    mx: "auto",
    width: a.width || {
      xs: "90%",
      large: 910
    }
  }), a.children);
}